import { render, staticRenderFns } from "./ResellerAccountsList.vue?vue&type=template&id=5d88b53d&"
import script from "./ResellerAccountsList.vue?vue&type=script&lang=js&"
export * from "./ResellerAccountsList.vue?vue&type=script&lang=js&"
import style0 from "./ResellerAccountsList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d88b53d')) {
      api.createRecord('5d88b53d', component.options)
    } else {
      api.reload('5d88b53d', component.options)
    }
    module.hot.accept("./ResellerAccountsList.vue?vue&type=template&id=5d88b53d&", function () {
      api.rerender('5d88b53d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Services/Hosting/Reseller/ResellerAccountsList.vue"
export default component.exports